module.exports = __webpack_public_path__ + "cd8b9f5fc07eb228cdbe667b41ae244b.jpg";